/**
 * LICITARS 3.0 - Chat8 Layout Component
 * Navy/Silver themed layout with glassmorphism effects
 * Preserves original structure while enhancing visual design
 */

import React from "react";

interface Chat8LayoutV3Props {
  header: React.ReactNode;
  perguntasSection: React.ReactNode;
  statusBar?: React.ReactNode;
}

/**
 * Chat8LayoutV3 - Estrutura principal do chat inteligente
 * Responsável apenas pelo layout visual e organização das áreas
 * Usa modal para mensagens em vez de seção inline
 * Aplica tema navy/silver com glassmorphism
 */
export const Chat8LayoutV3: React.FC<Chat8LayoutV3Props> = ({
  header,
  perguntasSection,
  statusBar,
}) => {
  return (
    <div
      id="chat8-root"
      className="chat8-root flex flex-col h-screen bg-navy-800 text-platinum"
      data-testid="chat8-root"
    >
      {/* Header */}
      {header}
      {/* Main Content */}
      <div
        id="chat8-main-content"
        className="chat8-main-content flex-1 flex flex-col"
        data-testid="chat8-main-content"
      >
        {/* Questions Panel - Occupies all available space */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {perguntasSection}
        </div>
      </div>
      {/* Status Bar */}
      {statusBar && (
        <div className="border-t border-navy">
          {statusBar}
        </div>
      )}
    </div>
  );
};

export default Chat8LayoutV3;
